import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom/cjs/react-router-dom.min';
import {useTranslation} from 'react-i18next';
import useAnimate from '../../hooks/useAnimate';
// import mui
import {
  makeStyles,
  withStyles,
  TextField,
  colors,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import {styled} from '@material-ui/core/styles';
// import components
import DashboardBanner from '../../_components/DashboardBanner';
import DashboardAnimate from '../../_components/DashboardAnimate';
import DashboardButtonBack from '../../_components/DashboardButtonBack';
import Preloader from '../../_components/Preloader';
import Success from './components/Success';
// import redux
import {connect} from 'react-redux';
import {userActions} from '../../_actions';
// import fetch
import axInst from '../../_helpers/axios-instance';
import Button from '@mui/material/Button';
import axInstTD from '../../_helpers/axios-td';

const Label = styled('label')({
  fontSize: 13,
  color: '#1C2A53',
  fontWeight: 400,
});

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 1246,
    margin: '0 auto',
    padding: '0 15px',
    overflowX: 'hidden',
  },

  body: {
    padding: '50px 0 30px 0',
    [theme.breakpoints.down(768)]: {
      padding: '30px 0 15px 0',
    },
  },

  title: {
    paddingBottom: 35,
  },
  card: {
    padding: '36px 62px 60px 62px',

    [theme.breakpoints.down('sm')]: {
      padding: 16,
    },
  },

  back: {
    paddingBottom: '34px',
  },

  card__title: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    fontSize: 16,
    fontWeight: 700,
    color: '#2F80ED',
    paddingBottom: 12,

    '& span': {
      fontWeight: 500,
      fontSize: 14,
      color: 'black',
    },
  },

  order__flex__sending: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 20,
    width: '100%',
    justifyContent: 'space-between',
    paddingBottom: 51,

    [theme.breakpoints.down(768)]: {
      flexDirection: 'column',
      gap: 30,
    },

    [theme.breakpoints.down('sm')]: {
      paddingBottom: 25,
      gap: 10,
      flexDirection: 'column',
    },
  },

  order__text: {
    display: 'flex',
    flexDirection: 'column',
    gap: 7,
    maxWidth: 420,

    [theme.breakpoints.down('sm')]: {
      gap: 10,
    },

    '& p': {
      fontWeight: 500,
      fontSize: 14,
      color: 'black',

      '& span': {
        color: '#555F7E',
        paddingLeft: 10,
      },
    },
  },

  place__form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },

  place__choose: {
    maxWidth: 109,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },

  place: {
    '& h2': {
      fontSize: 14,
      fontWeight: 500,
      paddingBottom: 16,

      [theme.breakpoints.down('sm')]: {
        paddingBottom: 8,
      },
    },
  },

  place__settings: {
    width: '100%',
    display: 'grid',
    gap: 16,
    gridTemplateColumns: 'repeat(4,1fr)',

    [theme.breakpoints.down(768)]: {
      gridTemplateColumns: 'repeat(2,1fr)',
    },
  },

  place__setting: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    maxWidth: 255,
  },

  button: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      paddingTop: 15,
    },
  },

  submitBtn: {
    border: 0,
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: 400,
    color: '#1F1F1F',
    maxWidth: '176px',
    background: '#FFBE00',
    fontSize: '13px',
    fontWeight: 700,
    lineHeight: '22px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    height: '38px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
      width: '100%',
    },
  },

  cashless__warning: {
    width: '100%',
    display: 'flex',
    textAlign: 'center',
    justifyItems: 'center',
    flexDirection: 'column',
    boxSizing: 'border-box',
    gap: 8,
    padding: 12,
    marginBottom: 40,
    borderRadius: 12,
    backgroundColor: '#EFEFF3FF',

    '& h5': {
      fontWeight: 'bold',
      color: 'red',
    },

    '& p': {
      color: 'red',
      fontSize: 17,
    },
  },

  novaPoshtaSelect: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 9,
  },

  senderOffice: {
    display: 'flex',
    gap: 9,
    alignItems: 'center',
  },

  senderOffice__title: {
    marginBottom: 'auto',
  },

  errorCreateBlock: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    gap: 6,
    textAlign: 'center',
    background: 'none',
    borderRadius: 12,
    border: '1px solid red',
    padding: 12,

    '& span': {
      color: 'red',
    },
  },
}));

const Input = withStyles({
  root: {
    border: '0.8px solid #8E95A9',
    height: '42px',
    borderRadius: '4px',
    transition: '0.3s',

    '& .MuiInputBase-input': {
      width: '100%',
      border: 0,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '10px !important',
    },

    '& .MuiFilledInput-root': {
      background: 'transparent',
    },
    '& .MuiInput-underline:before': {
      border: 'none',
      content: '',
    },
    '& .MuiInput-underline:after': {
      border: 'none',
      content: '',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      border: 'none',
    },
  },
})(TextField);

const defaultPlace = {
  volumetricWidth: '',
  volumetricLength: '',
  volumetricHeight: '',
  weight: '',
};

const TtnCreate = props => {
  const {userSelectedData, getOrderCreateInfo, orderCreateInfo} = props;
  const {id} = useParams();
  const {t} = useTranslation();
  const classes = useStyles();
  useAnimate();

  const [numberOfBlocks, setNumberOfBlocks] = useState(1);
  const [places, setPlaces] = useState([defaultPlace]);
  const [actions, setActions] = useState({
    isSuccess: false,
    disabled: false,
    errors: [],
    response: {},
  });

  // Состояния для "Новой Почты"
  const [query, setQuery] = useState({city: '', warehouse: ''});
  const [queries, setQueries] = useState({city: [], warehouse: []});
  const [selectedQuery, setSelectedQuery] = useState({
    City: {
      Present: '',
      DeliveryCity: '',
      MainDescription: '',
      Ref: '',
    },
    Warehouse: {
      Ref: '',
      Description: '',
      WarehouseStatus: '',
    },
  });

  const [isWarehouseEmpty, setIsWarehouseEmpty] = useState(
    orderCreateInfo?.sender?.sender_office?.length < 5,
  );

  const [isSearching, setIsSearching] = useState({
    city: false,
    warehouse: false,
  });

  useEffect(() => {
    getOrderCreateInfo(userSelectedData.customer_id, +id);

    if (orderCreateInfo?.sender?.sender_office?.length < 5) {
      setIsWarehouseEmpty(true);
    }
  }, []);

  const paymentTypeText = getPaymentTypeText(orderCreateInfo);

  const checkingEmptyFields = obj => Object.values(obj).some(value => !value);
  const getObjectError = index =>
    actions.errors.find(item => item.currentIndex === index);

  function getPaymentTypeText(orderInfo) {
    const payType = orderInfo?.recipient?.recipient_paytype;

    switch (payType) {
      case 'cash':
        return t('common:paytype_cash');
      case 'cashless':
        return t('common:paytype_cashless');
      default:
        return t('common:paytype_undefiend');
    }
  }

  const handlePlaceChange = (index, field, value) => {
    const newPlaces = [...places];
    newPlaces[index] = {...newPlaces[index], [field]: value};
    setPlaces(newPlaces);
  };

  const handleInputChange = e => {
    const value = parseInt(e.target.value, 10);

    const newNumberOfBlocks = isNaN(value) || value === 0 ? 1 : value;
    const newPlaces = Array(newNumberOfBlocks).fill(defaultPlace);

    setActions({isSuccess: false, disabled: false, errors: [], response: {}});
    setNumberOfBlocks(newNumberOfBlocks);
    setPlaces(newPlaces);
  };

  const onSubmit = e => {
    e.preventDefault();
    setActions(prev => ({...prev, errors: [], disabled: true}));

    const emptyInputs = [];
    places.forEach((place, index) => {
      const check = checkingEmptyFields(place);
      if (check) emptyInputs.push({...place, currentIndex: index});
    });

    if (emptyInputs.length > 0)
      return setActions(prev => ({
        ...prev,
        errors: emptyInputs,
        disabled: false,
        response: {},
        isSuccess: false,
      }));

    axInst
      .post('/api/register-invoice-number-warehouseman/', {
        order_id: id,
        customer_id: userSelectedData.customer_id,
        OptionsSeat: places,
        deliver_pay_sender:
          orderCreateInfo?.recipient?.recipient_paytype === 'cashless'
            ? true
            : false,
      })
      .then(response => {
        setActions(prev => ({
          ...prev,
          isSuccess: true,
          response: response?.data[0] || {},
        }));
      })
      .catch(err => {
        console.log(err);
        const serverError = err.response?.data || {
          warning: 'An error occurred',
        };
        setActions(prev => ({
          ...prev,
          errors: [...prev.errors, serverError],
        }));
      })
      .finally(() => {
        setActions(prev => ({...prev, disabled: false}));
      });
  };

  useEffect(() => {
    if (query.city?.length > 2 && isSearching.city) {
      axInstTD
        .post('https://api.novaposhta.ua/v2.0/json/', {
          modelName: 'AddressGeneral',
          calledMethod: 'searchSettlements',
          methodProperties: {
            CityName: query.city,
            Limit: 20,
          },
        })
        .then(response => {
          if (
            response.data &&
            response.data.data &&
            response.data.data[0] &&
            response.data.data[0].Addresses
          ) {
            const addresses = response.data.data[0].Addresses;
            setQueries(prevQueries => ({
              ...prevQueries,
              city: addresses,
            }));
          }
        })
        .catch(error => console.log('Error fetching cities:', error))
        .finally(() =>
          setIsSearching(prevState => ({...prevState, city: false})),
        );
    }

    if (
      selectedQuery.City.MainDescription.length > 0 &&
      Array.isArray(queries.city) &&
      queries.city.length === 0 &&
      !isSearching.warehouse &&
      (query.warehouse?.length < 2 || !query.warehouse?.length)
    ) {
      axInstTD
        .post('https://api.novaposhta.ua/v2.0/json/', {
          modelName: 'AddressGeneral',
          calledMethod: 'getWarehouses',
          methodProperties: {
            Language: 'UA',
            TypeOfWarehouseRef: '841339c7-591a-42e2-8233-7a0a00f0ed6f',
            CityName: selectedQuery.City.MainDescription,
          },
        })
        .then(response => {
          if (
            response.data &&
            response.data.data &&
            Array.isArray(response.data.data)
          ) {
            setQueries(prevQueries => ({
              ...prevQueries,
              warehouse: response.data.data,
            }));
          }
        })
        .catch(error => console.log('Error fetching cities:', error));
    }

    if (query.warehouse?.length > 2 && isSearching.warehouse) {
      axInstTD
        .post('https://api.novaposhta.ua/v2.0/json/', {
          modelName: 'AddressGeneral',
          calledMethod: 'getWarehouses',
          methodProperties: {
            Language: 'UA',
            CityName: selectedQuery.City.MainDescription,
            FindByString: query.warehouse,
          },
        })
        .then(response => {
          if (
            response.data &&
            response.data.data &&
            Array.isArray(response.data.data)
          ) {
            setQueries(prevQueries => ({
              ...prevQueries,
              warehouse: response.data.data,
            }));
          }
        })
        .catch(error => console.log('Error fetching cities:', error))
        .finally(() =>
          setIsSearching(prevState => ({...prevState, warehouse: false})),
        );
    }
  }, [
    query.city,
    query.warehouse,
    isSearching.city,
    isSearching.warehouse,
    selectedQuery.City.MainDescription,
    queries.city,
  ]);

  const handleQuerySelect = (type, data) => {
    if (type === 'city') {
      setSelectedQuery(prevState => ({
        ...prevState,
        City: {
          Present: data.Present,
          DeliveryCity: data.DeliveryCity,
          MainDescription: data.MainDescription,
          Ref: data.Ref,
        },
      }));
      setQuery(prevState => ({...prevState, city: data.MainDescription}));
      setQueries(prevState => ({...prevState, city: []}));
      setIsSearching(prevState => ({...prevState, city: false}));
    } else if (type === 'warehouse') {
      setSelectedQuery(prevState => ({
        ...prevState,
        Warehouse: {
          Ref: data.Ref,
          Description: data.Description,
          WarehouseStatus: data.WarehouseStatus,
        },
      }));
      setQuery(prevState => ({...prevState, warehouse: data.Description}));
      setQueries(prevState => ({...prevState, warehouse: []}));
      setIsSearching(prevState => ({...prevState, warehouse: false}));
    }
  };

  const handleSenderOfficeSave = () => {
    getOrderCreateInfo(
      userSelectedData.customer_id,
      +id,
      orderCreateInfo.sender_id,
      `${selectedQuery.City.MainDescription}; Нова Пошта; #${selectedQuery.Warehouse.Description}`,
    );
    if (orderCreateInfo?.sender?.sender_office?.length > 4) {
      setIsWarehouseEmpty(false);
    }
  };

  const handleChangeOffice = () => {
    setIsWarehouseEmpty(true);
    setSelectedQuery({
      City: {
        Present: '',
        DeliveryCity: '',
        MainDescription: '',
        Ref: '',
      },
      Warehouse: {
        Ref: '',
        Description: '',
        WarehouseStatus: '',
      },
    });
    setQueries({city: [], warehouse: []});
    setQuery({city: '', warehouse: ''});
    setIsSearching({warehouse: false, city: true});
  };

  const editIcon = () => {
    return (
      <Button
        type="icon"
        onClick={handleChangeOffice}
        style={{
          padding: 0,
          marginLeft: 8,
          minWidth: 'auto',
          width: '100%',
          maxWidth: 'min-content',
        }}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 13.3335H14"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 2.33316C11.2652 2.06794 11.6249 1.91895 12 1.91895C12.1857 1.91895 12.3696 1.95553 12.5412 2.0266C12.7128 2.09767 12.8687 2.20184 13 2.33316C13.1313 2.46448 13.2355 2.62038 13.3066 2.79196C13.3776 2.96354 13.4142 3.14744 13.4142 3.33316C13.4142 3.51888 13.3776 3.70277 13.3066 3.87435C13.2355 4.04593 13.1313 4.20184 13 4.33316L4.66667 12.6665L2 13.3332L2.66667 10.6665L11 2.33316Z"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
    );
  };

  return (
    <main className="dashboard">
      <DashboardBanner />
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.back}>
            <DashboardButtonBack />
          </div>
          <DashboardAnimate style={{transform: 'scale(0.97)'}}>
            {!actions?.isSuccess && (
              <div className={`dashboard-card ${classes.card}`}>
                {orderCreateInfo?.loading ? (
                  <div className="dashboard-card-empty">
                    <Preloader />
                  </div>
                ) : orderCreateInfo?.error ? (
                  <div className="dashboard-card-empty">
                    {t('common:unknown_error_label')}
                  </div>
                ) : orderCreateInfo?.is_no_access ? (
                  <div className="dashboard-card-empty">
                    {t('common:order_create_info_access_label')}
                  </div>
                ) : null}
                {!actions?.isSuccess && (
                  <h1 className={`dashboard-title ${classes.title}`}>
                    {t('common:create_TTN')}
                  </h1>
                )}
                <h2 className={classes.card__title}>
                  <svg
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.36969 23.1547C6.21453 23.1401 6.0684 23.0727 5.95622 22.963C5.87676 22.8835 5.81977 22.7843 5.79108 22.6756C5.76226 22.5663 5.76304 22.4514 5.79334 22.3426L5.79337 22.3426L5.79461 22.3379L6.93546 18.0829L6.9363 18.0797C7.08425 17.5128 7.37989 16.9953 7.79308 16.58C7.79324 16.5798 7.79341 16.5796 7.79357 16.5795L22.4959 1.8926C22.9152 1.49389 23.4718 1.27148 24.0506 1.27148C24.6298 1.27148 25.1867 1.49417 25.6062 1.89336L27.0495 3.32129C27.0499 3.32171 27.0503 3.32213 27.0508 3.32255C27.4603 3.73436 27.6902 4.29156 27.6902 4.8724C27.6902 5.45361 27.46 6.01115 27.05 6.42304C27.0498 6.42319 27.0497 6.42335 27.0495 6.4235L12.345 21.128C12.3447 21.1284 12.3443 21.1287 12.3439 21.1291C11.9243 21.5428 11.4068 21.8435 10.8397 22.0031L6.36969 23.1547ZM8.71978 21.7449L8.92393 21.949L9.20279 21.8743L10.6973 21.4737C10.6975 21.4737 10.6977 21.4736 10.6979 21.4735C11.1743 21.3467 11.6081 21.0948 11.9543 20.7438L12.5363 20.1771L12.8994 19.8236L12.5411 19.4653L9.47314 16.3974L9.12427 16.0485L8.77078 16.3927L8.18495 16.9631L8.18491 16.9631L8.18 16.968C7.83269 17.3157 7.58138 17.7474 7.45055 18.2212L7.45053 18.2212L7.44955 18.2248L7.04872 19.7202L6.97397 19.9991L7.17812 20.2032L8.71978 21.7449ZM12.9285 19.0778L13.2821 19.4314L13.6356 19.0778L24.0111 8.70241L24.3646 8.34885L24.0111 7.9953L20.9431 4.92738L20.5896 4.57383L20.236 4.92738L9.86062 15.3028L9.50707 15.6564L9.86062 16.0099L12.9285 19.0778ZM26.6627 6.05075L26.6648 6.04865C26.9723 5.73746 27.1448 5.3176 27.1448 4.8801C27.1448 4.44261 26.9723 4.02274 26.6648 3.71156L26.6646 3.71136L25.2309 2.26219L25.2297 2.26103C25.0761 2.1068 24.8936 1.98442 24.6925 1.90091C24.4915 1.81741 24.276 1.77442 24.0583 1.77442C23.8407 1.77442 23.6251 1.81741 23.4241 1.90091C23.2231 1.98442 23.0406 2.1068 22.887 2.26102L22.886 2.26205L21.3289 3.83455L20.9788 4.18809L21.3306 4.53991L24.3985 7.60782L24.7521 7.96138L25.1056 7.60782L26.6627 6.05075ZM27.524 27.7795H1.46984C1.39801 27.7795 1.32912 27.751 1.27833 27.7002C1.22754 27.6494 1.19901 27.5805 1.19901 27.5087C1.19901 27.4369 1.22754 27.368 1.27833 27.3172C1.32912 27.2664 1.39801 27.2379 1.46984 27.2379H27.524C27.5958 27.2379 27.6647 27.2664 27.7155 27.3172C27.7663 27.368 27.7948 27.4369 27.7948 27.5087C27.7948 27.5805 27.7663 27.6494 27.7155 27.7002C27.6647 27.751 27.5958 27.7795 27.524 27.7795Z"
                      fill="#F5F7FB"
                      stroke="#2F80ED"
                    />
                  </svg>
                  {t('common:order')}
                  <span>№{id}</span>
                </h2>
                <div className={classes.order__flex__sending}>
                  <div className={classes.order__text}>
                    <p>
                      {t('common:Recipient')}:
                      <span>
                        {orderCreateInfo?.recipient?.recipient_name || '-'}
                      </span>
                    </p>
                    <p>
                      {t('common:contact_info')}:
                      <span>
                        {orderCreateInfo?.recipient?.recipient_contact || '-'}
                      </span>
                    </p>
                    <p>
                      {t('common:delivery')}:
                      <span>
                        {(orderCreateInfo?.recipient?.recipient_delivery
                          ?.length > 5 &&
                          orderCreateInfo?.recipient?.recipient_delivery) ||
                          '-'}
                      </span>
                    </p>
                    <p>
                      {t('common:form_of_payment')}:
                      <span>{paymentTypeText}</span>
                    </p>
                    <p>
                      {t('common:return_delivery')}:
                      <span>
                        {orderCreateInfo?.recipient?.recipient_return_delivery
                          ? `${
                              orderCreateInfo?.recipient
                                ?.recipient_return_delivery
                            } ${t('common:uah')}`
                          : '-'}
                      </span>
                    </p>
                    <p>
                      {t('common:quanity_of_goods')}:
                      <span>
                        {orderCreateInfo?.recipient?.recipient_quantity_items ||
                          '-'}
                        &nbsp;{t('common:products_count')}
                      </span>
                    </p>
                  </div>
                  <div className={classes.order__text}>
                    <p>
                      {t('common:Sender')}:
                      <span>{orderCreateInfo?.sender?.sender_name || '-'}</span>
                    </p>
                    <p>
                      {t('common:contact_info')}:
                      <span>
                        {orderCreateInfo?.sender?.sender_contact || '-'}
                      </span>
                    </p>
                    <div className={classes.senderOffice}>
                      <p className={classes.senderOffice__title}>
                        {t('common:department_of_sender')}:
                        {!isWarehouseEmpty && (
                          <span>
                            {orderCreateInfo?.sender?.sender_office || '-'}
                            {editIcon()}
                          </span>
                        )}
                      </p>
                      {isWarehouseEmpty && (
                        <div className={classes.novaPoshtaSelect}>
                          <TextField
                            label="Оберіть місто"
                            variant="outlined"
                            fullWidth
                            value={query.city}
                            onChange={e => {
                              setQuery({city: e.target.value});
                              setIsSearching({city: true});
                            }}
                            style={{
                              height: 20,
                            }}
                            inputProps={{
                              style: {
                                padding: '5px 10px',
                                fontSize: '12px',
                              },
                            }}
                            InputLabelProps={{
                              shrink: true,
                              style: {
                                fontSize: '12px',
                                transform: 'translate(14px, -6px) scale(0.75)',
                              },
                            }}
                          />
                          {queries.city?.length > 0 && (
                            <List
                              style={{
                                position: 'absolute',
                                zIndex: 999,
                                width: '100%',
                                maxHeight: 200,
                                overflowY: 'auto',
                                backgroundColor: 'white',
                                border: '1px solid #ccc',
                                borderRadius: 4,
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                top: '30px',
                              }}>
                              {queries.city
                                .filter(
                                  city => city.StreetsAvailability === true,
                                )
                                .map(city => (
                                  <ListItem
                                    button
                                    key={city.Ref}
                                    onClick={() =>
                                      handleQuerySelect('city', city)
                                    }
                                    style={{
                                      padding: '4px 12px',
                                    }}>
                                    <ListItemText
                                      primary={city.MainDescription}
                                    />
                                  </ListItem>
                                ))}
                            </List>
                          )}

                          {selectedQuery.City.DeliveryCity.length > 0 &&
                            !isSearching.city && (
                              <div style={{position: 'relative'}}>
                                <TextField
                                  label="Оберіть відділення"
                                  variant="outlined"
                                  fullWidth
                                  value={query.warehouse}
                                  style={{
                                    marginTop: 8,
                                    height: 20,
                                  }}
                                  onChange={e => {
                                    setQuery({warehouse: e.target.value});
                                    setIsSearching({warehouse: true});
                                  }}
                                  inputProps={{
                                    style: {
                                      padding: '5px 10px',
                                      fontSize: '12px',
                                    },
                                  }}
                                  InputLabelProps={{
                                    shrink: true,
                                    style: {
                                      fontSize: '12px',
                                      transform:
                                        'translate(14px, -6px) scale(0.75)',
                                    },
                                  }}
                                />
                                {queries.warehouse?.length > 0 && (
                                  <List
                                    style={{
                                      position: 'absolute',
                                      zIndex: 999,
                                      width: '100%',
                                      maxHeight: 200,
                                      overflowY: 'auto',
                                      backgroundColor: 'white',
                                      border: '1px solid #ccc',
                                      borderRadius: 4,
                                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                      top: '30px',
                                    }}>
                                    {queries.warehouse.map(data => (
                                      <ListItem
                                        button
                                        key={data.Ref}
                                        onClick={() =>
                                          handleQuerySelect('warehouse', data)
                                        }
                                        style={{
                                          padding: '4px 12px',
                                        }}>
                                        <ListItemText
                                          primary={data.Description}
                                        />
                                      </ListItem>
                                    ))}
                                  </List>
                                )}
                              </div>
                            )}
                          {selectedQuery.City.DeliveryCity.length > 0 &&
                            !isSearching.city &&
                            selectedQuery.Warehouse.Description.length > 0 &&
                            !isSearching.warehouse && (
                              <Button
                                onClick={handleSenderOfficeSave}
                                variant="text"
                                color="primary">
                                {t('common:save')}
                              </Button>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {orderCreateInfo?.recipient?.recipient_paytype ===
                  'cashless' && (
                  <div className={classes.cashless__warning}>
                    <h5>{t('common:warning')}</h5>
                    <p>{t('common:ttn_create_cashless')}</p>
                  </div>
                )}
                <form className={classes.place__form}>
                  <div className={classes.place__choose}>
                    <Label>{t('common:number_of_seats_default')}</Label>
                    <Input
                      type="number"
                      required
                      placeholder="1"
                      min={1}
                      value={numberOfBlocks}
                      onChange={handleInputChange}
                    />
                  </div>
                  {Array.from({length: numberOfBlocks}, (_, index) => (
                    <div key={index} className={classes.place}>
                      <h2>
                        {t('common:place')} {index + 1}
                      </h2>
                      <div className={classes.place__settings}>
                        <div className={classes.place__setting}>
                          <Label>{t('common:width')}</Label>
                          <Input
                            type="number"
                            required
                            placeholder="00,00 см"
                            value={places[index]?.volumetricWidth || ''}
                            onChange={e =>
                              handlePlaceChange(
                                index,
                                'volumetricWidth',
                                e.target.value,
                              )
                            }
                            style={{
                              borderColor:
                                getObjectError(index) &&
                                !getObjectError(index)?.volumetricWidth
                                  ? '#FF392B'
                                  : '#8E95A9',
                            }}
                          />
                        </div>
                        <div className={classes.place__setting}>
                          <Label>{t('common:height')}</Label>
                          <Input
                            type="number"
                            required
                            placeholder="00,00 см"
                            value={places[index]?.volumetricHeight || ''}
                            onChange={e =>
                              handlePlaceChange(
                                index,
                                'volumetricHeight',
                                e.target.value,
                              )
                            }
                            style={{
                              borderColor:
                                getObjectError(index) &&
                                !getObjectError(index)?.volumetricHeight
                                  ? '#FF392B'
                                  : '#8E95A9',
                            }}
                          />
                        </div>
                        <div className={classes.place__setting}>
                          <Label>{t('common:length')}</Label>
                          <Input
                            type="number"
                            required
                            placeholder="00,00 см"
                            value={places[index]?.volumetricLength || ''}
                            onChange={e =>
                              handlePlaceChange(
                                index,
                                'volumetricLength',
                                e.target.value,
                              )
                            }
                            style={{
                              borderColor:
                                getObjectError(index) &&
                                !getObjectError(index)?.volumetricLength
                                  ? '#FF392B'
                                  : '#8E95A9',
                            }}
                          />
                        </div>
                        <div className={classes.place__setting}>
                          <Label>{t('common:weight')}</Label>
                          <Input
                            type="number"
                            required
                            placeholder="00,00 кг"
                            value={places[index]?.weight || ''}
                            onChange={e =>
                              handlePlaceChange(index, 'weight', e.target.value)
                            }
                            style={{
                              borderColor:
                                getObjectError(index) &&
                                !getObjectError(index)?.weight
                                  ? '#FF392B'
                                  : '#8E95A9',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className={classes.button}>
                    <button
                      disabled={
                        actions?.disabled ||
                        orderCreateInfo?.recipient?.recipient_delivery?.length <
                          5 ||
                        orderCreateInfo?.sender?.sender_office?.length < 5
                      }
                      className={classes.submitBtn}
                      onClick={onSubmit}>
                      {actions?.disabled
                        ? t('common:loading')
                        : t('common:issue_a_ttn')}
                    </button>
                    {actions.errors.length > 0 && (
                      <div className={classes.errorCreateBlock}>
                        {actions.errors.map((error, index) => (
                          <span key={index}>
                            {error.warning ===
                            'System does not have a valid Nova Poshta API key configured' ? (
                              <>{t('common:ttn_create_apikey')}</>
                            ) : (
                              error.warning ===
                                'Failed to create express document' && (
                                <>{t('common:ttn_create_express')}</>
                              )
                            )}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </form>
              </div>
            )}
          </DashboardAnimate>
          {actions?.isSuccess && (
            <Success
              orderId={id}
              numberOfBlocks={numberOfBlocks}
              data={actions?.response}
            />
          )}
        </div>
      </div>
    </main>
  );
};

function mapState(state) {
  const {
    userSelectedData,
    financeCalendarByOrganization,
    orderCreateInfo,
  } = state;
  return {
    userSelectedData,
    financeCalendarByOrganization,
    orderCreateInfo,
  };
}

const actionCreators = {
  getOrderCreateInfo: userActions.getOrderCreateInfo,
};

export default connect(mapState, actionCreators)(TtnCreate);
